import { TChatInListSchema } from '../../types/chatList';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ESpamListActionTypes {
  SetPending = 'chats/spamList/setPending',
  SetSucceed = 'chats/spamList/setSucceed',
  SetFailed = 'chats/spamList/setFailed',
}

export interface ISpamListRequest {
  timestampSpam?: number;
}

export type TSpamListPayload = TChatInListSchema[];

export type TSpamListActions =
  | ITypedReduxAction<ESpamListActionTypes.SetPending, ISpamListRequest>
  | ITypedReduxAction<ESpamListActionTypes.SetSucceed, TSpamListPayload>
  | ITypedReduxAction<ESpamListActionTypes.SetFailed, void>;
